const prefix = 'renewal';

export const GET_ALLOCATIONS = `${prefix}/GET_ALLOCATIONS`;
export const GET_ALLOCATIONS_SUCCEEDED = `${prefix}/GET_ALLOCATIONS_SUCCEEDED`;
export const GET_ALLOCATIONS_FAILED = `${prefix}/GET_ALLOCATIONS_FAILED`;

export const GET_BYPASSED_ALLOCATIONS = `${prefix}/GET_BYPASSED_ALLOCATIONS`;
export const GET_BYPASSED_ALLOCATIONS_SUCCEEDED = `${prefix}/GET_BYPASSED_ALLOCATIONS_SUCCEEDED`;
export const GET_BYPASSED_ALLOCATIONS_FAILED = `${prefix}/GET_BYPASSED_ALLOCATIONS_FAILED`;

export const GET_QUICK_ALLOCATIONS = `${prefix}/GET_QUICK_ALLOCATIONS`;
export const GET_QUICK_ALLOCATIONS_SUCCEEDED = `${prefix}/GET_QUICK_ALLOCATIONS_SUCCEEDED`;
export const GET_QUICK_ALLOCATIONS_FAILED = `${prefix}/GET_QUICK_ALLOCATIONS_FAILED`;

export const CLEAR_ALLOCATIONS = `${prefix}/CLEAR_ALLOCATIONS`;

export const SET_PURCHASE = `${prefix}/SET_PURCHASE`;
export const CHECK_RENEWAL = `${prefix}/CHECK_RENEWAL`;
